import * as Yup from 'yup';

export type LocationFormData = {
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  zipCode?: string;
  latitude?: number;
  longitude?: number;
};

export const createLocationFormValidationSchema = (requireCoordinates = false) =>
  Yup.object<LocationFormData>({
    address: Yup.string().required('Address is required'),
    city: Yup.string().required('City is required'),
    state: Yup.string().max(3, 'State must have maximum 3 letters').required('State is required'),
    zipCode: Yup.string().max(10, 'ZIP Code must have maximum 10 characters').required('ZIP Code is required'),
    latitude: requireCoordinates ? Yup.number().required('Latitude is required') : Yup.number().optional(),
    longitude: requireCoordinates ? Yup.number().required('Longitude is required') : Yup.number().optional()
  });

// Default schema with optional coordinates (for backward compatibility)
export const LocationFormValidationSchema = createLocationFormValidationSchema(false);
